/**
 * Created by andrey on 06.09.2021.
 */
const Merge2UnitsShop = function () {
    this.tabs = {};

    for (const tab in Merge2UnitsShop.PRODUCTS) {
        this.tabs[tab] = new Merge2UnitsShopTab(cleverapps.castType(tab));
    }
};

Merge2UnitsShop.getConfig = function (tab) {
    const boosterConfig = Merge2UnitsShop.BOOSTER_PRODUCTS[tab];
    const test = ABExperiments.Tests && ABExperiments.Tests.unitsShopBoosters;

    if (boosterConfig && test && cleverapps.abExperiments.getGroup(test) === "A") {
        return boosterConfig;
    }

    return Merge2UnitsShop.PRODUCTS[tab];
};

Merge2UnitsShop.prototype.isAvailable = function () {
    return cleverapps.user.checkAvailable(cleverapps.config.availables.UNITS_SHOP);
};

Merge2UnitsShop.prototype.getAvailableShops = function () {
    const shops = Merge2UnitsShop.SHOPS["0"];

    if (!shops) {
        return [];
    }

    return shops;
};

Merge2UnitsShop.prototype.reset = function () {
    this.load({});
    this.save();
};

Merge2UnitsShop.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.UNITS_SHOP) || {};
    
    for (const id in this.tabs) {
        this.tabs[id].load(data[id]);
    }
};

Merge2UnitsShop.prototype.save = function (fromServer) {
    cleverapps.dataLoader.save(DataLoader.TYPES.UNITS_SHOP, this.getInfo());

    if (!fromServer) {
        connector.synchronizer.addSendTask("unitsshop");
    }
};

Merge2UnitsShop.prototype.getInfo = function () {
    const info = {};
    for (const id in this.tabs) {
        info[id] = this.tabs[id].save();
    }
    return info;
};

Merge2UnitsShop.prototype.updateInfo = function (serverData = {}) {
    for (const id in this.tabs) {
        this.tabs[id].load(serverData[id]);
    }
    this.save(true);
};

Merge2UnitsShop.SHOPS = {
    "0": [{
        tab: ShopWindow.TABS.UNITS_RESOURCE,
        icon: bundles.tile_shop.frames.tab_resourceshop
    }]
};

cleverapps.override(cleverapps.EVENTS, {
    UNITS_SHOP_AVAILABLE: "ushop_available",
    UNITS_SHOP_FREE_PRODUCT: "ushop_buy_free",
    UNITS_SHOP_OPEN: "ushop_open",
    UNITS_SHOP_BUY: "ushop_buy",
    UNITS_SHOP_BUY_ADS: "ushop_buy_ads"
});